import { ShieldCheck, MessageCircle, Zap } from "lucide-react";

const values = [
  { icon: ShieldCheck, title: "Trust", desc: "Licensed, insured, and backed by 30 years of glowing reviews from homeowners and Utah's most particular custom builders." },
  { icon: MessageCircle, title: "Communication", desc: "We respond to every inquiry within 24 hours. You'll always know what's happening, what's next, and why." },
  { icon: Zap, title: "Speed", desc: "Efficient project timelines without ever cutting a corner. We move quickly because we plan thoroughly." },
];

export function ValueProps() {
  return (
    <section className="py-20 md:py-28 bg-primary text-primary-foreground">
      <div className="container-prose">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-xs tracking-[0.25em] uppercase font-semibold text-primary-foreground">Why RKD</span>
          <h2 className="mt-3 font-display text-3xl md:text-5xl leading-tight">Three things our clients say, every time.</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-10">
          {values.map((v, i) => (
            <div key={v.title} className="text-center">
              <div className="inline-flex h-16 w-16 items-center justify-center rounded-full border border-primary-foreground/40 mb-6">
                <v.icon className="h-7 w-7 text-primary-foreground" strokeWidth={1.5} />
              </div>
              <div className="text-primary-foreground font-display text-sm tracking-widest uppercase">0{i + 1}</div>
              <h3 className="mt-2 font-display text-2xl">{v.title}</h3>
              <p className="mt-4 text-primary-foreground/95 leading-relaxed">{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
